<template>
  <div class="fill-height">


    <v-card class="fill-height">
      <v-card-title class="p-1">
        <v-chip
            label small
            class="ma-2"
            color="secondary">
          گزارش ثبت اسناد
        </v-chip>
        <v-spacer/>
        <v-btn light icon @click="$router.push('/home')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

   <PageView  :show-msg.sync="showDialog" :model="model" />
      <v-card-text>
        <v-spacer/>
        <v-row>
          <v-col
              cols="12"
              md="3">

            <v-autocomplete
                :items="buildingList"
                v-model="buildingId"
                @input="handleInput"
                dense
                outlined
                :error-messages="getError('buildingId')"
                auto-select-first append-icon="fas fa-angle-down"
                label="انتخاب مجتمع"

            />

          </v-col>
          <v-col
              cols="12"

              md="3">
            <date-picker placeholder="از تاریخ" v-model="dateFrom" color="#3b5694" clearable
                         auto-submit>
            </date-picker>
            <span style="color: red" v-if="getError('dateFrom')" v-text="getError('dateFrom')"/>
          </v-col>
          <v-col
              cols="12"
              md="3">
            <date-picker placeholder="تا تاریخ" v-model="dateTo" color="#3b5694" clearable
                         auto-submit>
            </date-picker>
            <span style="color: red" v-if="getError('dateTo')" v-text="getError('dateTo')"/>
          </v-col>
          <v-col
              cols="12"
              md="3" class="d-inline-flex">
            <v-text-field outlined dense placeholder="نام" v-model="inp"
            >
            </v-text-field>
            <v-btn small class="mx-1" fab color="primary" @click="search">
              <v-icon>mdi-cloud-search</v-icon>
            </v-btn>
          </v-col>

        </v-row>


        <v-spacer/>
      </v-card-text>
      <v-card-text>
        <b-table
            :items="dataItems"
            :fields="columns"
            show-empty
            sticky-header="450px"
            id="style-1"
            striped>
          <template #cell(message)="row">
            {{ truncateWords(row.item.message, 15) }}
          </template>
          <template #cell(actions)="row">

            <v-btn depressed small color="info"
                   @click="forView(row.item)" class="mr-1 ">
              مشاهده
            </v-btn>
          </template>
        </b-table>

      </v-card-text>
    </v-card>

  </div>
</template>

<script>
import Reporting from "./Service";
import {mapMutations} from "vuex";
import PageView from "./PageView"

export default {

  name: 'Manager',
  components: {
    PageView
  },
  data() {
    return {
      buildingId: '',
      dateFrom: '',
      dateTo: '',
      inp: '',
      showDialog: false,
      buildingList: [],
      model: {},
      dataItems: [],
      bindingErrors: [],

      columns: [
        {key: 'building', label: 'نام مجتمع ',},
        {key: 'fullName', label: 'نام شخص',},
        {key: 'userName', label: 'نام کاربری',},
        {key: 'unitName', label: 'واحد',},
        {key: 'dateText', label: 'تاریخ ثبت سند',},
        {key: 'createdAtTxt', label: 'تاریخ ایجاد سند',},
        {key: 'sendDateText', label: 'تاریخ ارسال پیام',},
        {key: 'message', label: 'پیام'},
        {key: 'actions', label: ''},
      ],

    };

  },

  methods: {
    ...mapMutations({
      setDrawer: 'SET_DRAWER',
      setMini: 'SET_MINI',
    }),
    handleInput(value) {
      this.$emit('input', value)
    },
    forView(e) {
      Reporting.getById(e.id).then(response => {
            if (response && response.status === 200) {
              this.model = response.data
              this.showDialog = true
            }
      })
    },
    // محدود کردن تعداد کلمات در ستون جدول
    truncateWords(text, limit) {
      if (!text) return "";
      const words = text.split(" ");
      return words.length > limit
          ? words.slice(0, limit).join(" ") + "..."
          : text;
    },
    getError(key) {
      if (this.bindingErrors && this.bindingErrors.length > 0) {
        let error = this.bindingErrors.find(({fieldName}) => fieldName === key);
        if (error && error.message) return error.message[0]
      }
      return ''
    },

    fillDataItems() {
      Reporting.getPage().then(response => {
        this.buildingList = response.data.buildingList
      });
    },

    search() {
      this.dataItems = []
      this.bindingErrors = []
      this.$progress({message: 'درحال جستجو...'}, true)
      Reporting.search(this.buildingId, this.inp, this.dateFrom, this.dateTo).then(response => {
        this.$root.$emit('Progress')
        if (response && response.status === 200) {
          this.dataItems = response.data
        } else if (response && response.response.status === 400) {
          this.bindingErrors = response.response.data;
        }
      })
    },

  },


  created() {
    this.fillDataItems()
    this.setDrawer(false)
  }

}
</script>

<style>
.table th, .table td {
  padding: 5px !important;
}

</style>
